var blogStylists = {
    init: function(){
        this.filters();
    },
    
    filters: function(){
    
        $('body').on('click','.stylistys-filters__link',function(e) {
            e.preventDefault();
            var $el = $(this),
            url = $el.attr('href');

            if($el.hasClass('active')){
                var tmp = url.split('/tagged');
                url = tmp[0];
            }
            
            quickFilter.updateView(url);
        });
        
    }
}


//document ready
$(function() {

    blogStylists.init();

});
